<template>
  <CustomPage title="订单中心" style="background: #f7f7f7" backRoute="Mine">
    <div slot="content" style="height: 100%">
      <div class="order-container">
        <div class="tabs">
          <div class="tab" :class="{ active: active === item.value }" v-for="item in tabs" :key="item.value"
            @click="tabClick(item.value)">
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div class="list">
          <component ref="saleorderlist" :key="active" :is="component_c" :tabType="active" />
        </div>
      </div>
      <!-- <BoughtDialog/> -->
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page.vue'
import CustomView from '@/components/custom-view.vue'
import AfterSale from './components/AfterSale'
import InSale from './components/InSale'
import BoughtDialog from "@/components/BoughtDialog.vue";
export default {
  components: { CustomPage, CustomView, AfterSale, InSale, /*BoughtDialog*/ },
  data() {
    return {
      active: 0,
      tabs: [
        { name: '全部', value: 0, components: 'InSale' },
        { name: '待付款', value: 1, components: 'InSale' },
        { name: '待发货', value: 2, components: 'InSale' },
        { name: '待收货', value: 3, components: 'InSale' },
        { name: '已完成', value: 4, components: 'InSale' },
        { name: '售后', value: 5, components: 'AfterSale' },
      ],
    }
  },
  created() {
    if (this.$route.query.hasOwnProperty('active')) {
      this.active = Number(this.$route.query.active)
    }
  },
  computed: {
    component_c() {
      const i = this.tabs.find((item) => item.value === this.active)
      return i.components
    },
  },
  methods: {
    tabClick(val) {
      this.active = val
      this.$router.push({ path: '/mine/order', query: { active: val } })
    },
  },
  beforeRouteUpdate(to, from, next) {
    // console.log("to", to);
    if (from.name === 'OrderInSale') {
      console.log(911)
      if (to.query.active) this.active = Number(to.query.active)
      this.$refs.saleorderlist.checkUpdateNo()
    }
    next()
  },
}
</script>

<style lang="less" scoped>
.order-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .tabs {
    display: flex;
    padding: 22px 0 20px;
    background: #fff;

    .tab {
      flex: auto;
      text-align: center;

      span {
        display: inline-block;
        padding: 8px 28px;
        font-size: 24px;
        color: #666;
        line-height: 24px;
      }

      &.active span {
        color: #fff;
        background: #e82035;
        border-radius: 40px;
      }
    }
  }

  .list {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
}
</style>
